import React, { useState } from 'react';
import moment from 'moment';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

const RetencionesMasivasTicketsSearch = (props) => {
  const { from: asFrom, to: asTo } = props;

  const to = !!asTo ? moment(asTo) : moment();
  const from = !!asFrom ? moment(asFrom) : moment().subtract(7, 'days');

  const [state, setState] = useState({
    date: [from.toDate(), to.toDate()],
  });

  const handleOnKeywordChange = (keyword) => {
    handleOnSearch(keyword, state.label);
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const handleOnDateChange = (date) => {
    const from = moment(date[0]);
    const to = moment(date[1]);

    props.onDateChange({
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });

    setState({
      ...state,
      date,
    });
  };

  const getOmnisearchLegend = () => {
    const { label } = state;

    let legend = 'Omnisearch';

    switch (label) {
      case 'cfdi_uuid':
        legend = 'Folio Fiscal';
        break;
      case 'emisor_rfc':
        legend = 'Emisor RFC';
        break;
      case 'receptor_nacional_rfc':
        legend = 'Receptor RFC';
        break;
      case 'receptor_nacionalidad':
        legend = 'Receptor Nacionalidad';
        break;
      case 'receptor_nacional_nom_den_raz_soc':
        legend = 'Receptor Nacional Nombre';
        break;
      case 'receptor_extranjero_nom_den_raz_soc':
        legend = 'Receptor Extranjero Nombre';
        break;
      case 'mes_ini':
        legend = 'Mes Inicio';
        break;
      case 'mes_fin':
        legend = 'Mes final';
        break;
      case 'ejercicio':
        legend = 'Ejercicio';
        break;
      case 'monto_total_operacion':
        legend = 'Monto total operación';
        break;
      default:
        break;
    }

    return legend;
  };

  const handleOnSelectLabel = (name, event) => {
    const { id } = event.target;

    setState({
      ...state,
      label: id,
    });

    const { search } = props;

    if (!!search) {
      handleOnSearch(search, id);
    }
  };

  const handleOnSearch = (search, field) => {
    props.onKeywordChange({
      search,
      field,
    });
  };

  const { date } = state;
  const { search = '' } = props;

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="pr-2 pb-2">
        <CalendarDateRangePicker
          value={date}
          onDateChange={handleOnDateChange}
        />
      </div>
      <div className="flex-fill search-container">
        <SearchInput
          onKeywordChange={handleOnKeywordChange}
          onClear={handleOnSearchClear}
          value={search}
        >
          <DropdownButton
            variant="outline-secondary"
            title={getOmnisearchLegend()}
            id="search-index"
            onSelect={handleOnSelectLabel}
          >
            <Dropdown.Item id="">Sin filtro</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item id="cfdi_uuid">Folio Fiscal</Dropdown.Item>
            <Dropdown.Item id="emisor_rfc">Emisor RFC</Dropdown.Item>
            <Dropdown.Item id="receptor_nacional_rfc">Receptor RFC</Dropdown.Item>
            <Dropdown.Item id="receptor_nacionalidad">Receptor Nacionalidad</Dropdown.Item>
            <Dropdown.Item id="receptor_nacional_nom_den_raz_soc">Receptor Nacional Nombre</Dropdown.Item>
            <Dropdown.Item id="receptor_extranjero_nom_den_raz_soc">Receptor Extranjero Nombre</Dropdown.Item>
            <Dropdown.Item id="mes_ini">Mes inicio</Dropdown.Item>
            <Dropdown.Item id="mes_fin">Mes Final</Dropdown.Item>
            <Dropdown.Item id="ejercicio">Ejercicio</Dropdown.Item>
            <Dropdown.Item id="monto_total_operacion">Monto total operacion</Dropdown.Item>
          </DropdownButton>
        </SearchInput>
      </div>
    </div>
  );
};

export default RetencionesMasivasTicketsSearch;
